import { render, staticRenderFns } from "./dbEventEdit.vue?vue&type=template&id=36167a46&scoped=true&"
import script from "./dbEventEdit.vue?vue&type=script&lang=js&"
export * from "./dbEventEdit.vue?vue&type=script&lang=js&"
import style0 from "./dbEventEdit.vue?vue&type=style&index=0&id=36167a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36167a46",
  null
  
)

export default component.exports